/*
 * Nightglow Header
 * ------------------------------------------------------------
 * Desktop dropdown + mega menu hover interaction.
 *
 * - Hover opens menu
 * - Leaving menu closes it
 * - Mouse click does not toggle it
 * - Keyboard interaction remains available
 * - Touch/mobile behavior remains Dawn native
 */

(() => {
  const DESKTOP_HOVER_QUERY =
    '(min-width: 990px) and (hover: hover) and (pointer: fine)';

  const hoverMedia = window.matchMedia(DESKTOP_HOVER_QUERY);

  const initNightglowHeaderHover = () => {
    const header = document.querySelector('.nightglow-header');

    if (!header) return;

    const headerMenus = Array.from(
      header.querySelectorAll(
        '.header__inline-menu > .list-menu--inline > li > header-menu'
      )
    );

    if (!headerMenus.length) return;

    let closeTimer = null;

    const closeMenu = (headerMenu) => {
      const details = headerMenu.querySelector(':scope > details');

      if (!details) return;

      const summary = details.querySelector(':scope > summary');

      details.removeAttribute('open');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }

      /*
       * Also close nested dropdowns when the parent closes.
       */
      details.querySelectorAll('details[open]').forEach((nestedDetails) => {
        nestedDetails.removeAttribute('open');

        const nestedSummary =
          nestedDetails.querySelector(':scope > summary');

        if (nestedSummary) {
          nestedSummary.setAttribute('aria-expanded', 'false');
        }
      });
    };

    const closeOtherMenus = (currentMenu) => {
      headerMenus.forEach((headerMenu) => {
        if (headerMenu !== currentMenu) {
          closeMenu(headerMenu);
        }
      });
    };

    const openMenu = (headerMenu) => {
      const details = headerMenu.querySelector(':scope > details');

      if (!details) return;

      const summary = details.querySelector(':scope > summary');

      closeOtherMenus(headerMenu);

      details.setAttribute('open', '');

      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    };

    headerMenus.forEach((headerMenu) => {
      const details = headerMenu.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');

      if (!details || !summary) return;

      /*
       * Open dropdown / mega menu on hover.
       */
      headerMenu.addEventListener('mouseenter', () => {
        if (!hoverMedia.matches) return;

        window.clearTimeout(closeTimer);

        openMenu(headerMenu);
      });

      /*
       * Small delay makes moving from the menu label
       * into the dropdown feel more natural.
       */
      headerMenu.addEventListener('mouseleave', () => {
        if (!hoverMedia.matches) return;

        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          closeMenu(headerMenu);
        }, 120);
      });

      /*
       * On desktop mouse devices, clicking the summary should
       * not close/toggle the menu.
       *
       * event.detail === 0 normally indicates keyboard activation,
       * so keyboard users keep Dawn's native interaction.
       */
      summary.addEventListener('click', (event) => {
        if (!hoverMedia.matches) return;
        if (event.detail === 0) return;

        event.preventDefault();

        openMenu(headerMenu);
      });

      /*
       * Dropdown mode can contain another <details> level.
       * Make those child dropdowns hover-based as well.
       */
      const nestedDetails = details.querySelectorAll(
        '.header__submenu details'
      );

      nestedDetails.forEach((nestedDetail) => {
        const nestedSummary =
          nestedDetail.querySelector(':scope > summary');

        if (!nestedSummary) return;

        nestedDetail.addEventListener('mouseenter', () => {
          if (!hoverMedia.matches) return;

          nestedDetail.setAttribute('open', '');
          nestedSummary.setAttribute('aria-expanded', 'true');
        });

        nestedDetail.addEventListener('mouseleave', () => {
          if (!hoverMedia.matches) return;

          nestedDetail.removeAttribute('open');
          nestedSummary.setAttribute('aria-expanded', 'false');
        });

        nestedSummary.addEventListener('click', (event) => {
          if (!hoverMedia.matches) return;
          if (event.detail === 0) return;

          event.preventDefault();

          nestedDetail.setAttribute('open', '');
          nestedSummary.setAttribute('aria-expanded', 'true');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initNightglowHeaderHover
    );
  } else {
    initNightglowHeaderHover();
  }
})();